import { formatTimeStamp } from "../../api/callData";
import { getOrderStatusStyles } from "../../utils/orderUtils";
import { Icon } from "@iconify/react/dist/iconify.js";
import ReviewStatusIndicator from "./ReviewStatusIndicator";

const OrdersCards = ({
    paginatedOrders,
    selectedOrder,
    searchParams,
    setSelectedOrder,
    cardRef,
    getEquipmentList,
    getOrderStatus,
    getTotalAmount
}) => {
    const handleOrderClick = (order) => {
        // Add to browser history when opening order details
        const newParams = new URLSearchParams(searchParams);
        newParams.set('id', order.metadata?.stream_sid);
        window.history.pushState({}, '', `?${newParams.toString()}`);
        setSelectedOrder(order);
    };

    return (
        <div className="xl:hidden space-y-2 p-2">
            {paginatedOrders.map((order, index) => {
                const ref = index === 0 ? cardRef : null;
                return (
                    <div
                        key={order.metadata?.stream_sid}
                        ref={ref}
                        className={`p-3 flex flex-col gap-3 rounded-md cursor-pointer transition-all duration-300 ease-out-in bg-background hover:border hover:border-primary-70 hover:scale-[1.01]
                            ${selectedOrder?.metadata?.stream_sid === order.metadata?.stream_sid ? 'card-container' : ''}`}
                        onClick={() => handleOrderClick(order)}
                    >
                        <div className="text-base font-semibold flex items-center justify-between">
                            <span className={getEquipmentList(order.cart_data || order.booking_info).startsWith('Equipment') ? 'text-font-secondary' : 'text-font-primary'}>
                                {getEquipmentList(order.cart_data || order.booking_info)}
                            </span>
                            <span className="text-sm text-font-secondary">
                                #{order.cart_data?.summary?.cart_id || order.booking_info?.booking_status?.booking_id || order.id}
                            </span>
                        </div>

                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2 flex-wrap">
                                <div className={`p-1.5 rounded text-xs flex items-center gap-0.5 text-font-primary justify-center ${getOrderStatusStyles(getOrderStatus(order.cart_data || order.booking_info, order.booking_resolved), order.booking_resolved).className}`}>
                                    <Icon icon={getOrderStatusStyles(getOrderStatus(order.cart_data || order.booking_info, order.booking_resolved), order.booking_resolved).icon} className="text-lg" />
                                    <span className="text-font-primary">{getOrderStatus(order.cart_data || order.booking_info, order.booking_resolved)}</span>
                                </div>
                                <ReviewStatusIndicator order={order} compact={true} />
                            </div>
                            <span className={`text-sm ${getTotalAmount(order.cart_data || order.booking_info).startsWith('$') ? 'font-semibold text-primary' : 'text-font-secondary'}`}>
                                {getTotalAmount(order.cart_data || order.booking_info)}
                            </span>
                        </div>

                        <div className="flex items-start justify-between">
                            <span className="font-semibold text-font-primary text-sm">
                                {order.metadata?.caller_id || 'N/A'}
                            </span>
                            <span className="text-sm text-font-secondary">
                                {formatTimeStamp(order.metadata?.timestamp)}
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default OrdersCards;
